<template>
  <div style="display: flex">
    <div v-if="!loading" class="line-button" @click="loading=true,loginWithLine()">
      <div class="line-button__icon">
        <img src="../../../assets/lineIcon.png" alt="">
      </div>
      <div class="line-button__vertical"></div>
      <div class="line-button__text">
        <slot>LINEでログイン</slot>
      </div>
    </div>
    <div v-else class="line-button">
      <div class="line-button__icon">
        <img src="../../../assets/lineIcon.png" alt="">
      </div>
      <div class="line-button__vertical"></div>
      <div class="line-button__text">
        <slot>LINEでログイン</slot>
        <v-progress-circular
          indeterminate
          color="white"
          size="25"
        ></v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  // clientIdはpropsとして受け取り、defaultは環境変数から取得する
  props: {
    mode: {
      type: String,
      default: 'default', // merge, replace, signupなど
    },
  },
  data: () => ({
    state: '',
    loading: false,
    clientId: "",
  }),
  created() {
    this.clientId = this.mode != "replace" ? process.env.VUE_APP_LINE_CLIENT_ID : process.env.VUE_APP_LINE_CLIENT_ID_OLD
  },
  methods: {
    async getState(){
      // CloudFunctionsのlineLoginStartを、https on callで呼び出す
      const functions = firebase.functions()
      const lineLoginStart = functions.httpsCallable('lineLoginStart')
      const { data } = await lineLoginStart({ mode: this.mode })
      const { sessionId, state } = data

      // `line:${state}`をキーにsessionIdをlocalStorageに保存する。
      // まず、既にline:から値があれば削除する
      const keys = Object.keys(localStorage)
      keys.forEach(key => {
        if (key.startsWith(`${this.clientId}:`)) {
          localStorage.removeItem(key)
        }
      })

      // 保存する
      localStorage.setItem(`${this.clientId}:${state}`, sessionId)
      return state
    },
    async loginWithLine() {
      localStorage.removeItem("pathBeforeSignup")
      localStorage.setItem('pathBeforeLINE', this.$route.path)
      const response_type = encodeURIComponent('code');
      const redirect_uri = `${window.location.origin}/lineauthhandle?mode=${this.mode}`;
      const scope = encodeURIComponent('openid profile');
      const state = await this.getState()
      if (process.env.VUE_APP_TEMP_CITY_ID == 'kashiwanoha' && this.mode == 'replace') {
        // bot_prompt=aggressiveを削除
        const url = `https://access.line.me/oauth2/v2.1/authorize?response_type=${response_type}&client_id=${this.clientId}&`
          + `redirect_uri=${redirect_uri}&state=${state}&scope=${scope}`;
        window.location.href = url;
        return
      }
      const url = `https://access.line.me/oauth2/v2.1/authorize?response_type=${response_type}&client_id=${this.clientId}&`
        + `redirect_uri=${redirect_uri}&state=${state}&bot_prompt=aggressive&scope=${scope}`;
      window.location.href = url;
    }
  }
}
</script>
<style scoped>
.line-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: 100%;
    margin: 0 auto;
    cursor: pointer;
    border-radius: 9999px;
    background: #06c755;
}
.line-button__icon {
    margin: 0 10px 0 13px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.line-button__icon img {
    width: 40px;
    height: 40px;
}
.line-button__vertical {
    width: 1px;
    height: 40px;
    background: #000;
    opacity: 0.08;
}
.line-button__text {
    font-size: 1rem;
    height: 50%;
    font-weight: normal;
    color: #fff;
    margin: 0 40px 0 30px;
}
@media screen and (max-width:599px) {
  .line-button__text {
    font-size: 0.8rem;
    margin: 0 20px 0 10px;
  }
}
</style>
